import React, { Component } from "react";
import Predefine_3_VNeck_FullS_Cricket from "../components/Predefine_3_VNeck_FullS_Cricket/Predefine_3_VNeck_FullS_Cricket";

export class Predefine_3_VNeck_FullS_CricketPage extends Component {
  render() {
    return <Predefine_3_VNeck_FullS_Cricket />;
  }
}

export default Predefine_3_VNeck_FullS_CricketPage;
